import script from "./CasesSentToCourt.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasesSentToCourt.vue?vue&type=script&setup=true&lang=ts"

import "./CasesSentToCourt.vue?vue&type=style&index=0&id=2500e70a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2500e70a"]])

export default __exports__